




import Vue from 'vue'

interface Props {
  filterValue: string
}

interface Computed {
  newFilterValue: string
}

export default Vue.extend<{}, {}, Computed, Props>({
  props: {
    filterValue: {
      required: true,
    },
  },
  computed: {
    newFilterValue: {
      get() {
        return this.filterValue
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  mounted() {
    this.newFilterValue = this.filterValue
  },
})
